<template>
  <div v-frag>
    <ColorHeader
      v-if="collection.header_type === 'color'"
      :collection="collection"
    />
    <MonotoneHeader v-if="collection.header_type === 'monotone'" :collection="collection" />
    <WishlistsCollectionHeader
      v-if="collection.header_type === 'wishlist'"
      :collection="collection"
    />
  </div>
</template>
<script>
import frag from 'vue-frag';
import ColorHeader from './ColorHeader.vue';
import MonotoneHeader from './MonotoneHeader.vue';
import WishlistsCollectionHeader from './WishlistsCollectionHeader.vue';

export default {
  components: {
    ColorHeader,
    MonotoneHeader,
    WishlistsCollectionHeader,
  },
  directives: { frag },
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },
};
</script>
